/* Regal Rediance custom scripts */
(function () {
  if (window.__rrLoaded) return;
  window.__rrLoaded = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function toast(msg) {
    var t = document.querySelector('.rr-toast');
    if (!t) { t = document.createElement('div'); t.className = 'rr-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
      return r.json();
    });
  }

  function go(code, dest) {
    dest = dest || 'checkout';
    if (code) window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + dest);
    else window.location.href = root + dest;
  }

  function money(cents) {
    return 'R' + (Math.round(cents) / 100).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ');
  }

  function busy(btn, on) {
    if (!btn) return;
    if (on) { btn._t = btn.innerHTML; btn.disabled = true; btn.innerHTML = 'Adding…'; }
    else { btn.disabled = false; if (btn._t) btn.innerHTML = btn._t; }
  }

  /* Simple add buttons: data-rr-add="variantId" [data-rr-qty] [data-rr-go="cart|checkout"] */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rr-add]');
    if (!b) return;
    e.preventDefault();
    var ids = String(b.getAttribute('data-rr-add')).split(',').filter(Boolean);
    if (b.hasAttribute('data-rr-current')) ids[0] = currentVariantId(ids[0]);
    var qty = parseInt(b.getAttribute('data-rr-qty') || '1', 10);
    busy(b, true);
    addItems(ids.map(function (id) { return { id: Number(id), quantity: qty }; }))
      .then(function () {
        var g = b.getAttribute('data-rr-go');
        var code = b.getAttribute('data-rr-code');
        if (g) return go(code, g);
        busy(b, false); toast('Added to your cart ✓');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (b.hasAttribute('data-rr-reload')) window.location.reload();
      })
      .catch(function (err) { busy(b, false); toast(err.message); });
  });

  /* Build-your-own bundle */
  function initBYO(el) {
    var picks = el.querySelectorAll('input[type=checkbox]');
    var msg = el.querySelector('[data-rr-byo-msg]');
    var tot = el.querySelector('[data-rr-byo-tot]');
    var btn = el.querySelector('[data-rr-byo-btn]');
    function update() {
      var sel = Array.prototype.filter.call(picks, function (p) { return p.checked; });
      var n = sel.length, sum = sel.reduce(function (a, p) { return a + Number(p.dataset.price); }, 0);
      var pct = n >= 3 ? 20 : n === 2 ? 15 : 0;
      var code = n >= 3 ? 'GLOWTRIO' : n === 2 ? 'GLOWDUO' : '';
      var after = sum * (100 - pct) / 100;
      if (n === 0) msg.textContent = 'Pick any 2 products to unlock 15% off — or 3+ for 20% off.';
      else if (n === 1) msg.textContent = 'Great start! Add 1 more to save 15%.';
      else if (n === 2) msg.textContent = 'Glow Duo unlocked: 15% off (code GLOWDUO). Add 1 more for 20%!';
      else msg.textContent = 'Glow Trio unlocked: 20% off (code GLOWTRIO) ✨';
      tot.innerHTML = n ? (pct ? '<s>' + money(sum) + '</s> ' : '') + '<b>' + money(after) + '</b>' + (pct ? ' · you save ' + money(sum - after) : '') : '';
      btn.disabled = n < 2;
      btn.dataset.code = code;
    }
    picks.forEach(function (p) { p.addEventListener('change', update); });
    btn.addEventListener('click', function () {
      var sel = Array.prototype.filter.call(picks, function (p) { return p.checked; });
      if (sel.length < 2) return;
      busy(btn, true);
      addItems(sel.map(function (p) { return { id: Number(p.value), quantity: 1 }; }))
        .then(function () { go(btn.dataset.code, 'checkout'); })
        .catch(function (err) { busy(btn, false); toast(err.message); });
    });
    update();
  }

  /* Quantity breaks on product page */
  function currentVariantId(fallback) {
    var inp = document.querySelector('product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]');
    return (inp && inp.value) || fallback;
  }
  function initQB(el) {
    var btn = el.querySelector('[data-rr-qb-btn]');
    btn.addEventListener('click', function () {
      var r = el.querySelector('input[name="rr-qb"]:checked');
      var qty = r ? parseInt(r.value, 10) : 1;
      var id = currentVariantId(el.dataset.variant);
      busy(btn, true);
      addItems([{ id: Number(id), quantity: qty }])
        .then(function () { go('', 'cart'); })
        .catch(function (err) { busy(btn, false); toast(err.message); });
    });
  }

  /* Delivery estimate: working days from today */
  function addWorkdays(d, n) {
    var x = new Date(d);
    while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
    return x;
  }
  function initETA(el) {
    var min = parseInt(el.dataset.min || '7', 10), max = parseInt(el.dataset.max || '14', 10);
    var f = { weekday: 'short', day: 'numeric', month: 'short' };
    var now = new Date();
    var a = addWorkdays(now, min).toLocaleDateString('en-ZA', f);
    var b = addWorkdays(now, max).toLocaleDateString('en-ZA', f);
    var out = el.querySelector('[data-rr-eta-dates]');
    if (out) out.textContent = a + ' – ' + b;
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-rr-byo]:not([data-rr-ready])').forEach(function (el) { el.setAttribute('data-rr-ready', ''); initBYO(el); });
    scope.querySelectorAll('[data-rr-qb]:not([data-rr-ready])').forEach(function (el) { el.setAttribute('data-rr-ready', ''); initQB(el); });
    scope.querySelectorAll('[data-rr-eta]:not([data-rr-ready])').forEach(function (el) { el.setAttribute('data-rr-ready', ''); initETA(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
